import FeatureGates from "@atlaskit/feature-gate-js-client";
import { ProductKeys } from "@atlassiansox/asc-stargate";

import ChatWidgetProvider from "@/components/chat-widget/src/chat-widget";
import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import { LicenseContextProvider } from "@/components/license-provider/src";
import { SiteSelectorContextProvider } from "@/components/site-selector-modal";
import { IntercomProvider } from "@/libraries/intercom/src";
import { JiraServiceManagementSoftwarePageTemplate } from "@/templates/software/jira/service-management/jira-service-management-software-page/src";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const JiraServiceManagementSoftwarePage = () => {
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-jsm"
    );
    const isSalesWidgetBxpWebPlatform: boolean = checkFeatureFlagGate(
        featureFlags.salesWidgetBxpWebPlatform
    );

    const isSalesWidgetBxpWebPlatformDeveloper: boolean = checkFeatureFlagGate(
        featureFlags.salesWidgetBxpWebPlatformDeveloper
    );
    if (isSalesWidgetBxpWebPlatformDeveloper) {
        return (
            <LicenseContextProvider>
                <SiteSelectorContextProvider
                    analyticsPrefix="jsm.show"
                    productKey={ProductKeys.JIRA_SERVICE_DESK}
                >
                    <ChatWidgetProvider>
                        <CrossFlowTouchpointProvider
                            productKeys={[ProductKeys.JIRA_SERVICE_DESK]}
                            screenName="wacJsmProductTourPage"
                        >
                            <JiraServiceManagementSoftwarePageTemplate />
                        </CrossFlowTouchpointProvider>
                    </ChatWidgetProvider>
                </SiteSelectorContextProvider>
            </LicenseContextProvider>
        );
    } else if (isSalesWidgetBxpWebPlatform) {
        return (
            <LicenseContextProvider>
                <SiteSelectorContextProvider
                    analyticsPrefix="jsm.show"
                    productKey={ProductKeys.JIRA_SERVICE_DESK}
                >
                    <ChatWidgetProvider>
                        <CrossFlowTouchpointProvider
                            productKeys={[ProductKeys.JIRA_SERVICE_DESK]}
                            screenName="wacJsmProductTourPage"
                        >
                            <JiraServiceManagementSoftwarePageTemplate />
                        </CrossFlowTouchpointProvider>
                    </ChatWidgetProvider>
                </SiteSelectorContextProvider>
            </LicenseContextProvider>
        );
    } else {
        return (
            <LicenseContextProvider>
                <SiteSelectorContextProvider
                    analyticsPrefix="jsm.show"
                    productKey={ProductKeys.JIRA_SERVICE_DESK}
                >
                    <IntercomProvider
                        appId={"p0ww63i2"}
                        triggerBoot={isBootIntercom}
                    >
                        <CrossFlowTouchpointProvider
                            productKeys={[ProductKeys.JIRA_SERVICE_DESK]}
                            screenName="wacJsmProductTourPage"
                        >
                            <JiraServiceManagementSoftwarePageTemplate />
                        </CrossFlowTouchpointProvider>
                    </IntercomProvider>
                </SiteSelectorContextProvider>
            </LicenseContextProvider>
        );
    }
};
